<template>
  <ul>
    <li v-for="firstLayerData in getFlatStructureAsTree(flatData)" :key="firstLayerData.id">
      {{ firstLayerData.label }}
      <ul v-for="secondLayerData in firstLayerData.children" :key="secondLayerData.id">
        <li>
          {{ secondLayerData.label }}
          <ul v-for="thirdLayerData in secondLayerData.children" :key="thirdLayerData.id">
            <li>{{ thirdLayerData.label }}</li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import clean from 'lodash-clean';

export default {
  name: 'TreeStructure',
  data() {
    return {};
  },
  props: {
    flatData: {
      type: Array,
      required: true,
    },
    separator: {
      type: String,
      default: '|',
    }
  },
  methods: {
    getFlatStructureAsTree(flatDataArray) {
      let currentPath;
      let lastPath;
      let node;
      let parent;
      const map = {
        '': {
          children: [],
        },
      };
      let stack = [''];

      for (let i = 0; i < flatDataArray.length; i += 1) {
        const nodes = flatDataArray[i].split(this.separator);
        for (let j = 0; j < nodes.length; j += 1) {
          currentPath = `${nodes.slice(0, j + 1).join(this.separator)}`;
          const name = nodes[j];
          lastPath = stack[stack.length - 1];
          parent = map[lastPath];

          if (!map[currentPath]) {
            node = {
              id: currentPath,
              label: name,
              children: [],
            };
            parent.children.push(node);
            map[currentPath] = node;
          }
          stack.push(currentPath);
        }
        stack = stack.slice(0, 1);
      }
      return flatDataArray.length === 0 ? [] : clean(map[''].children);
    }
  },
};
</script>
